import React from 'react';

import { Chart, Axis, Tooltip, Geom } from "bizcharts";
import "./style.css"
import { Select, Spin, message,Empty } from 'antd';
import EventSet from "./../../../assets/PubJs/hcPub"
import "./../../../assets/PubJs/Bcharts"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import createHistory from 'history/createHashHistory';//路由切换地址
import $ from "jquery"
import law from "./../../../assets/images/YWTJ.svg"//图片
const Option = Select.Option;
const history = createHistory();//定义history路由



let _ChartsTitle = null;
class ChartsTitle extends React.Component {

    state = {
        year: "最新",
        beginTime: "",
        endTime: "",
        Com_Code: "",
        data: [],
        yearData: []
    };

    changeChartData(res) {
        _BarTwo.setState({
            data: res,
        })
    }


    //根据条件获取数据图
    getChartData(begin, end) {
        let SendData = {
            "endDate": begin,
            "beginDate": end,
            "UserCode": EventSet.getUserInfo().CU_Code,
            "UserComCode": EventSet.getUserInfo().xxhjcompanycode,
        };
        $.ajax({
            url: Hcurl + "/HomePage/GetChartDataP",
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            contentType: "application/json",
            data: JSON.stringify(SendData),
            async: false,
            success: function (res) {
                console.log('55',res)
                 _ChartsTitle.changeChartData(res)
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }

    //处理选择年份时间开始与结束
    getYearTime(e) {
        let _this = this;

        if (_ChartsTitle.state.Com_Code === "") {
            _BarTwo.setState({
                placeho: "暂无企业数据..."
            })
            return
        }

        if (e === "最新") {
            let Time = new Date();
            let TimeYear = Time.getFullYear();
            let TimeMonth = Time.getMonth() + 1;
            //console.log(TimeMonth);
            if (TimeMonth === 12) {
                _this.setState({
                    beginTime: TimeYear + "-1-1",
                    endTime: TimeYear + "-12-1",
                }, () => {
                    _this.getChartData(_this.state.beginTime, _this.state.endTime)
                })
            } else {
                _this.setState({
                    beginTime: TimeYear + "-" + TimeMonth + "-" + '1',
                    endTime: (TimeYear - 1) + "-" + (TimeMonth + 1) + "-" + "1"
                }, () => {
                    _this.getChartData(_this.state.beginTime, _this.state.endTime)
                })
            }
        } else {
            _this.setState({
                beginTime: e + "-1-1",
                endTime: e + "-12-1",
            }, () => {
                _this.getChartData(_this.state.beginTime, _this.state.endTime)
            })
        }
    }

    //年份改变
    handleChangeYear(value) {
        this.setState({
            year: value
        });
        this.getYearTime(value)
    }

    componentDidMount() {
        _ChartsTitle = this;
        $.ajax({
            url: Hcurl + "/HomePage/GetYears",
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                _ChartsTitle.setState({
                    yearData: res == null ? [] : res
                })
            },
            error: function (data, err) {
                //console.log(data,err)
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    render() {
        return (

            <div className="C_topTitle clear">
               
                <img style={{ width: "18px", position: "relative", top: "7.5px", marginRight: "6px" }} className="left" src={law} alt="" />
                <span className="left">业务统计</span>
                <div className="right" style={{ marginLeft: "20px" }}>
                    <span>年份&nbsp;:&nbsp;&nbsp;</span>
                    <Select size={"default"} value={this.state.year} className="right" style={{ width: 120 }} onChange={this.handleChangeYear.bind(this)}>
                        <Option value="最新">最新</Option>
                        {
                            this.state.yearData.map(function (e) {
                                return <Option key={e.YEAR} value={e.YEAR}>{e.YEAR}</Option>
                            })
                        }
                    </Select>
                </div>
            </div>
        )
    }

}


//柱状图之双柱（Bizcharts写的）
let _BarTwo = null;
class BarTwo extends React.Component {

    state = {
        data: [],
        DateTime: [],
        placeho: <Spin />
    };

    //获取该用户所绑定企业code集合
    getCompanyCode() {
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code,
        };

        $.ajax({
            url: Hcurl + "/CompanyCore/GetSelectCompany",
            type: "post",
             headers: {
                 "token": EventSet.getUserInfo()['token']
             },
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let resData = JSON.parse(res);
                let codeArr = []
                for (let i = 0; i < resData.length; i++) {
                    codeArr[i] = resData[i].Com_Code
                }
                //console.log(codeArr.toString())
                _ChartsTitle.setState({
                    Com_Code: codeArr.toString()
                }, () => {
                    _ChartsTitle.getYearTime("最新")
                })
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    componentDidMount() {
        _BarTwo = this;
        this.getCompanyCode()
        // EventSet.PageDo()
    }

    render() {

        // const dataBar = this.state.data;
        // const dataArr = this.state.DateTime;
        // const ds = new DataSet();
        // const dv = ds.createView().source(dataBar);
        // dv.transform({
        //     type: 'fold',
        //     fields: dataArr,
        //     key: '月份', // key字段
        //     value: '月数据量', // value字段
        // });
        const text = <div style={{ position: 'relative', top: '48%', textAlign: 'center' }}>{this.state.placeho}</div>
        return (
        <div>{this.state.data.length>0?<Chart  height={this.props.hei - 70} data={this.state.data}  padding={[40, 30, 40, 50]} forceFit>
        <Axis name="month" />
        <Axis name="monthData" />
        <Tooltip
          // crosshairs用于设置 tooltip 的辅助线或者辅助框
          // crosshairs={{
          //  type: "y"
          // }}
        />
        <Geom type="interval" position="month*monthData" tooltip={['month*monthData', (month, monthData) => {
            return {
                //自定义 tooltip 上显示的 title 显示内容等。
                name: monthData,
            };
            }]} />
      </Chart>:<Empty style={{marginTop:'180px'}} image={Empty.PRESENTED_IMAGE_SIMPLE} />}</div>
            
            
        )
    }

}


let _App = null;
class App extends React.Component {
    state = {
        wid: 0
    }
    componentWillMount() {
        _App = this;
    }

    componentDidMount() {

    }
    render() {

        return (
            <div className="C_content">
                <ChartsTitle />
                <div className="C_content_son">
                    <BarTwo hei={this.props.hei} />
                </div>
            </div>
        )
    }
}
export default App


// WEBPACK FOOTER //
// ./src/components/Content/Home/Bcharts.js